const stats = [
  { value: "1200+", label: "全站韩漫数量" },
  { value: "480万+", label: "累计阅读人次" },
  { value: "每日更新", label: "热门连载不等待" },
  { value: "免费无删减", label: "全集下拉畅读" },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex items-center min-h-[560px] md:min-h-[640px] overflow-hidden">
      {/* 背景大图 */}
      <img
        src="https://readdy.ai/api/search-image?query=cinematic%20wide%20illustration%20of%20a%20stack%20of%20floating%20Korean%20webtoon%20comic%20books%20and%20smartphone%20screens%20with%20glowing%20story%20panels%2C%20stylized%20artistic%20manhwa%20style%2C%20warm%20amber%20orange%20and%20deep%20charcoal%20color%20palette%2C%20dramatic%20golden%20light%2C%20immersive%20night%20reading%20atmosphere%2C%20abstract%20and%20non-realistic%2C%20high%20quality%20digital%20art&width=1800&height=1200&seq=hero-bg-01&orientation=landscape"
        alt="韩漫免费无删减下拉阅读背景图"
        title="韩漫免费看全集 高清无删减阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* 深色遮罩提升文字对比 */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/85 via-background-950/70 to-background-950/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 to-transparent" />

      <div className="relative w-full mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-600/20 border border-primary-500/40 text-primary-300 px-4 py-1.5 text-sm mb-6">
            <i className="ri-fire-fill" />
            每日热门韩漫免费更新
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-50 leading-tight md:leading-[1.15]">
            韩漫免费无删减
            <span className="text-primary-400">下拉式阅读</span>，看全集不等待
          </h1>
          <p className="mt-5 text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl">
            海量热门韩漫免费看全集，章节完整、无删减连贯阅读。每日更新热门榜单，点开即读、收藏不迷路，随时随地畅享高清韩漫免费阅读体验。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#featured"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 hover:bg-primary-500 text-background-950 px-6 py-3 text-base font-semibold transition-colors cursor-pointer"
            >
              <i className="ri-play-circle-fill text-xl" />
              立即开启阅读
            </a>
            <a
              href="#updates"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-800/80 hover:bg-background-700 border border-background-700 text-foreground-100 px-6 py-3 text-base font-medium transition-colors cursor-pointer"
            >
              <i className="ri-time-line text-xl" />
              查看今日更新
            </a>
          </div>
        </div>

        {/* 数据亮点 */}
        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 max-w-4xl">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-900/70 border border-background-700/60 backdrop-blur px-4 py-4 md:px-5 md:py-5"
            >
              <p className="font-heading text-xl md:text-2xl font-bold text-primary-400">{s.value}</p>
              <p className="mt-1 text-xs md:text-sm text-foreground-400">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}